import { Component, OnInit, ViewChild } from "@angular/core";
import { UserViewComponent } from "./user-view/user-view.component";
import { PaginationColumn } from "../_component/pagination-client-side/pagination-column.class";
import { TranslateService } from "@ngx-translate/core";
import { CompanyService } from "../company/company.service";
import { RowsLoaderService } from "../../_services/rows-loader.service";
import { HeaderModel } from "../../_component/header/header.model";
import { UserService } from "../../_services";
import { ThisPlatform } from "../../_services/platform.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { PaginationClientSideOptions } from "../_component/pagination-client-side/pagination-client-side-options";
import { HeaderService } from "src/app/_services/header.service";

@Component({
  selector: "app-users",
  templateUrl: "./users.page.html",
  styleUrls: ["./users.page.scss"],
})
export class UsersPage implements OnInit {
  users: any;
  usersFilter: any;
  userActive: boolean = true;
  componentRef: any = UserViewComponent;
  dataFilter = "";
  userCompany = true;
  showLoader: boolean = true;
  page: string = "company";
  defaultPage: string = "company";

  columnsDefinition: PaginationColumn[] = [
    {
      name: "",
      displayName: "",
      size: 1,
      sortable: false,
    },
    {
      name: "firstName",
      displayName: "USERS.NAME",
      size: 2,
      sortable: true,
    },
    {
      name: "lastName",
      displayName: "USERS.SURNAME",
      size: 2,
      sortable: true,
    },
    {
      name: "companyName",
      displayName: "ADD_COMPANY.COMPANY",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return this.companyService.getCompanyName(row.idCompany);
      },
    },
    {
      name: "email",
      displayName: "E-mail",
      size: 3,
      sortable: true,
    },
    {
      name: "mobilePhone",
      displayName: "USERS.MOBILE",
      size: 2,
      sortable: true,
    },
  ];

  headerInit: HeaderModel = {
    segmentsChangeFunc: ($event) => this.segmentChanged($event),
    userSettingsBreakpoint: 1050,
    segments: [
      {
        name: "USERS.USERS_COMPANY",
        value: "company",
        permissionKeys: ["user.view.company"],
      },
      {
        name: "USERS.USERS_ALL",
        value: "all",
        permissionKeys: ["user.view.active"],
      },
      {
        name: "USERS.INACIVE",
        value: "inactive",
        permissionKeys: ["user.view.inactive"],
      },
    ],
    title: "USERS.USERS",
  };

  rowsLoader: RowsLoaderService;
  userAddPermission: boolean;

  subscription: Subscription;

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    headerStickyPosition: 62,
    addButtonText: "USERS.ADD_USER",
    noResultsAddLink: "/app/users/add",
    permissionAdd: "user.add"
  };

  @ViewChild("searchBar")
  searchBar;

  constructor(
    public translateService: TranslateService,
    public companyService: CompanyService,
    public userServ: UserService,
    public p: ThisPlatform,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private headerServ: HeaderService,
  ) {}

  rowsLoaderInit() {
    if (this.rowsLoader) {
      if (this.searchBar.ngModel) {
        this.usersFilter = this.users.filter((s) => {
          return (
            (
              s.firstName +
              " " +
              s.lastName +
              " " +
              this.companyService.getCompanyName(s.idCompany) +
              " " +
              s.email +
              " " +
              s.mobilePhone
            )
              .toUpperCase()
              .includes(this.searchBar.ngModel.toUpperCase()) &&
            (s.status === 0 || this.userActive)
          );
        });
      } else {
        this.usersFilter = this.users;
      }
      this.rowsLoader.init(this.usersFilter);
    }
  }

  async ngOnInit() {
    await this.companyService.loadCompaniesSync();
    
    this.userAddPermission = await this.userServ.hasRolesAsync(["user.add"]);

    this.subscription = this.activatedRoute.queryParamMap.subscribe(
      (params) => {
        if (params.get("section")) {
          this.page = params.get("section");
          this.setQueryParam(this.page);

          if (this.page === "company") {
            this.userActive = true;
            this.userCompany = true;
          } else if (this.page === "all") {
            this.userActive = true;
            this.userCompany = false;
          } else if (this.page === "inactive") {
            this.userActive = false;
            this.userCompany = false;
          }
        } else {
          this.page = this.defaultPage;
          this.headerServ.setHeaderInit(this.headerInit);
        }
        this.getUsers();
        this.userServ.lastSegment = this.page;
      }
    );
  }
  
  ionViewWillEnter() {
    this.headerInit.activeSegment = this.page;
    this.headerServ.setHeaderInit(this.headerInit);
  }

  getUsers() {
    this.showLoader = true;

    if (this.userCompany) {
      this.userServ
        .getUsersCompany({
            idCompany: this.userServ.userStorage.idCompany,
            active: this.userActive.toString(),
          })
        .subscribe((res) => {
          this.users = this.usersFilter = res;
          this.rowsLoaderInit();
          this.showLoader = false;
        });
    } else {
      this.userServ
        .getUsersCompany({ active: this.userActive.toString()})
        .subscribe((res) => {
          this.users = this.usersFilter = res;
          this.rowsLoaderInit();
          this.showLoader = false;
        });
    }
  }

  onChangeSearch() {
    this.rowsLoaderInit();
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  segmentChanged(event: any) {
    this.page = event.detail.value;
    this.setQueryParam(this.page);
    this.userServ.lastSegment = this.page;
  }

  setQueryParam(value) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { section: value },
      queryParamsHandling: "merge", // remove to replace all query params by provided
    });
  }
}
